import { Modal } from 'components/Modal';
import { ModalBody } from 'components/Modal/ModalBody';
import { useContext } from 'react';
import { CheckboxButton } from 'components/CheckboxButton';
import { EarlyDayLogoGraphic } from 'graphics';
import { ArrowLeftLongIcon, AsteriskIcon } from 'icons/outline';
import { ModalActions } from 'components/Modal/ModalActions';
import { Button } from 'components/Button';
import noop from 'lodash/noop';
import { HiringUpdateFlowContext } from 'features/EmployerHiringUpdateFlow/EmployerHiringUpdateContext';
import { HiringUpdateFlowSteps } from 'features/EmployerHiringUpdateFlow/EmployerHiringUpdateFlow.constants';
import { InputInstructions } from 'features/EmployerHiringUpdateFlow/InputInstructions';

export const HiredHowStep = () => {
  const { open, step, goToNextStep, goToPreviousStep, personnelProviders, setPersonnelProviders } =
    useContext(HiringUpdateFlowContext);

  const handleChange = (provider: string) => {
    setPersonnelProviders((prev) =>
      prev.includes(provider) ? prev.filter((item) => item !== provider) : [...prev, provider],
    );
  };

  return (
    <Modal
      panelProps={{
        className: 'sm:!max-w-[476px]',
      }}
      open={open && step === HiringUpdateFlowSteps.WHICH_PLATFORM}
      heading={<span className="text-primary-pure-blue">How did you hire for this role?</span>}
      actionRequired
      onClose={noop}
    >
      <ModalBody>
        <InputInstructions>Select all that apply.</InputInstructions>

        <div className="mt-6 flex flex-col gap-4">
          <CheckboxButton
            className="!px-4"
            checked={personnelProviders.includes('EarlyDay')}
            onChange={() => handleChange('EarlyDay')}
          >
            <div className="ml-2 flex items-center gap-4">
              <div className="flex-none w-5 flex justify-center items-center">
                <EarlyDayLogoGraphic className="w-4 h-4" />
              </div>
              <span className="text-sm font-normal text-neutral-dark whitespace-normal">
                I hired someone with EarlyDay
              </span>
            </div>
          </CheckboxButton>

          <CheckboxButton
            className="!px-4"
            checked={personnelProviders.includes('Other')}
            onChange={() => handleChange('Other')}
          >
            <div className="ml-2 flex items-center gap-4">
              <AsteriskIcon className="w-5 h-5 flex-none text-primary-pure-blue" />
              <span className="text-sm font-normal text-neutral-dark whitespace-normal">
                I hired using another method
              </span>
            </div>
          </CheckboxButton>
        </div>
      </ModalBody>

      <ModalActions>
        <Button
          type="button"
          size="lg"
          fullWidth
          onClick={goToNextStep}
          disabled={!personnelProviders.length}
        >
          Confirm
        </Button>
        <Button type="button" size="lg" variant="outline" onClick={goToPreviousStep} fullWidth>
          <ArrowLeftLongIcon className="mr-2" />
          <span>Go back</span>
        </Button>
      </ModalActions>
    </Modal>
  );
};
